<div class="entity-table-scroll" [class.article-table]="kind === 'article'" [class.topic-table]="kind === 'topic'" [class.competitor-table]="kind === 'topic' && !showCompetitorAction">
  <p-table
    [value]="visibleRows"
    [paginator]="visibleRows.length > pageSize"
    [rows]="pageSize"
    [first]="first"
    (onPage)="first = $event.first"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first}–{last} of {totalRecords}"
    styleClass="p-datatable-sm p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="star-col" aria-label="Followed"></th>
        <th pSortableColumn="name">
          <span class="column-heading">
            <span class="column-title">{{ kind === 'article' ? 'Title' : 'Name' }}</span>
            <p-sortIcon field="name"></p-sortIcon>
            <button type="button" class="column-filter-button" [attr.aria-label]="'Filter ' + (kind === 'article' ? 'title' : 'name')"
              [attr.aria-expanded]="!!filterOpen.name" (click)="toggleFilter('name', $event)">
              <i class="pi pi-filter"></i>
            </button>
          </span>
          <input *ngIf="filterOpen.name" pInputText type="search" class="column-filter"
            [attr.aria-label]="kind === 'article' ? 'Filter title' : 'Filter name'"
            [(ngModel)]="nameFilter" (ngModelChange)="resetPage()"
            (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
        </th>
        <th *ngIf="kind === 'article'" pSortableColumn="date">
          <span class="column-heading"><span class="column-title">Date</span> <p-sortIcon field="date"></p-sortIcon></span>
        </th>
        <th *ngIf="kind === 'author' || kind === 'outlet' || kind === 'article'" pSortableColumn="groups">
          <span class="column-heading">
            <span class="column-title">{{ kind === 'author' ? 'Outlets' : kind === 'outlet' ? 'Outlet Groups' : 'Outlet' }}</span>
            <p-sortIcon field="groups"></p-sortIcon>
            <button *ngIf="kind !== 'author'" type="button" class="column-filter-button"
              [attr.aria-label]="kind === 'article' ? 'Filter outlet' : 'Filter outlet group'"
              [attr.aria-expanded]="!!filterOpen.groups" (click)="toggleFilter('groups', $event)">
              <i class="pi pi-filter"></i>
            </button>
          </span>
          <select *ngIf="filterOpen.groups" class="column-filter"
            [attr.aria-label]="kind === 'article' ? 'Filter outlet' : 'Filter outlet group'"
            [(ngModel)]="groupFilter" (ngModelChange)="resetPage()"
            (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <option value="">All {{ kind === 'article' ? 'outlets' : 'outlet groups' }}</option>
            <option *ngIf="kind === 'article'" value="__none__">(none)</option>
            <ng-container *ngIf="kind === 'outlet'">
              <option *ngFor="let group of outletGroupOptions" [value]="group.id">{{ group.name }}</option>
            </ng-container>
            <ng-container *ngIf="kind === 'article'">
              <option *ngFor="let group of groupOptions" [value]="group">{{ group }}</option>
            </ng-container>
          </select>
        </th>
        <th *ngIf="kind !== 'article'" pSortableColumn="category">
          <span class="column-heading">
            <span class="column-title">Category</span> <p-sortIcon field="category"></p-sortIcon>
            <button type="button" class="column-filter-button" aria-label="Filter category"
              [attr.aria-expanded]="!!filterOpen.category" (click)="toggleFilter('category', $event)">
              <i class="pi pi-filter"></i>
            </button>
          </span>
          <select *ngIf="filterOpen.category" class="column-filter"
            aria-label="Filter category" [(ngModel)]="categoryFilter" (ngModelChange)="resetPage()"
            (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            <option value=""></option>
            <option *ngFor="let category of categoryOptions" [value]="category">{{ category }}</option>
          </select>
        </th>
        <th *ngIf="kind === 'author' || kind === 'outlet'" pSortableColumn="count" title="Past year">
          <span class="column-heading"><span class="column-title">My Coverage <i class="pi pi-question-circle" pTooltip="Number of articles that mentioned My Company"></i></span> <p-sortIcon field="count"></p-sortIcon></span>
        </th>
        <th *ngIf="kind === 'author' || kind === 'outlet'" pSortableColumn="recent" title="Past year">
          <span class="column-heading"><span class="column-title">Most Recent <i class="pi pi-question-circle" pTooltip="Most recent article that mentioned My Company"></i> </span> <p-sortIcon field="recent"></p-sortIcon></span>
        </th>
        <th *ngIf="kind !== 'article'" class="entity-actions" aria-label="Row actions"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="star-col">
          <app-star-toggle [active]="true" (toggled)="toggleFollow(row)"></app-star-toggle>
        </td>
        <td>
          <span class="title-cell">
            <button type="button" class="entity-name" [title]="row.name" (click)="selectRow(row)">{{ row.name }}</button>
          </span>
        </td>
        <td *ngIf="kind === 'article'">{{ row.date ? (row.date | date : 'mediumDate') : '—' }}</td>
        <td *ngIf="kind === 'author' || kind === 'outlet' || kind === 'article'" [title]="row.groups">{{ row.groups || '—' }}</td>
        <td *ngIf="kind !== 'article'">{{ row.category || '—' }}</td>
        <td *ngIf="kind === 'author' || kind === 'outlet'">{{ row.count }}</td>
        <td *ngIf="kind === 'author' || kind === 'outlet'">{{ row.recent ? (row.recent | date : 'mediumDate') : '—' }}</td>
        <td *ngIf="kind !== 'article'" class="entity-actions">
          <span class="entity-action-controls">
            <app-star-toggle *ngIf="kind !== 'topic' || showCompetitorAction"
              [active]="true"
              [showFollowButton]="false"
              [labels]="['Primary', 'Secondary']"
              [activeLabel]="row.category"
              (toggled)="toggleFollow(row)"
              (labelToggled)="toggleLabel(row, $event)"
            ></app-star-toggle>
            <button type="button" class="entity-edit" pTooltip="Edit" aria-label="Edit"
              (click)="edit.emit(row.item)"><i class="pi pi-pencil"></i></button>
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td [attr.colspan]="kind === 'author' || kind === 'outlet' ? 7 : kind === 'article' ? 4 : 4">No results</td></tr>
    </ng-template>
  </p-table>
</div>
<div *ngIf="kind === 'topic' && showCompetitorAction" class="entity-table-footer">
  <button pButton type="button" icon="pi pi-plus" label="New Topic"
    class="p-button-text p-button-sm new-topic-button" (click)="create.emit()"></button>
</div>
